import { render, staticRenderFns } from "./dataviewheader.vue?vue&type=template&id=a9825b22"
import script from "./dataviewheader.vue?vue&type=script&lang=js"
export * from "./dataviewheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports